import { LiteTradePortfolioListItemStyled } from "./styled/LiteTradePortfolioStyled.js";
import { IconAsset } from "../../../../components/icon/Icon.jsx";
import { memo, useCallback, useMemo } from "react";
import amountFormat from "../../../../utils/amountFormat.js";
import LiteTradePortfolioPositionInfo from "./LiteTradePortfolioPositionInfo";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectLiteTradeMarketDataBySymbol } from "../../liteTradeSelectors";
import withDebounced from "../../../../hooks/withDebounced.js";
import { LITE_TRADE_POSITION_SIDE } from "../../liteTradeConstants.js";
import classNames from "classnames";

const LiteTradePortfolioPositionRow = ({item, marketDataSymbol, from}) => {
    const getCurrentPrice = useCallback((forPl = false) => {
        let side = item.side === LITE_TRADE_POSITION_SIDE.BUY ? 'ask' : 'bid';
        if (forPl) side = side === 'ask' ? 'bid' : 'ask';
        return marketDataSymbol?.[side] ?? 0;
    }, [item.side, marketDataSymbol]);

    const getOpenMargin = useMemo(() => {
        const amount = item.assetInstance.lotsToAmount(item.quantity / item.assetInstance.getLotSize(), getCurrentPrice());
        return amount === null ? '-' : '$' + amountFormat(item.assetInstance.lotsToAmount(item.quantity / item.assetInstance.getLotSize(), getCurrentPrice()), 2);
    }, [getCurrentPrice, item]);

    const getPL = useMemo(() => {
        const price = getCurrentPrice(true);
        if (!price) {
            return null;
        }
        const amount = item.assetInstance.getPositionPL(item, price);

        return amount !== null && <span
            style={{color: amount > 0 ? 'var(--color-green)' : 'var(--color-red)'}}>{amountFormat(amount, 2, '$')}</span>;
    }, [getCurrentPrice, item]);

    return <LiteTradePortfolioListItemStyled className={classNames({
        'inactive': !item.assetInstance.isTradingNow()
    })}>
        <div className="col-left"><IconAsset symbol={item.symbol}/></div>
        <div className="col-center">
            <div className={'f16'}>{item.assetInstance.asset.info.description}</div>
            <div className={'asset-row-info f14 fw600 color-white-60'}>
                <LiteTradePortfolioPositionInfo
                    item={item}
                    hideSymbol={from !== 'portfolio'}
                />
            </div>
        </div>
        <div className="col-right">
            <div className={'f16 fw600'}>{getOpenMargin}</div>
            <div className={'f14 fw600'}>{getPL}</div>
        </div>
    </LiteTradePortfolioListItemStyled>;
}

const mapStateToProps = createStructuredSelector({
    marketDataSymbol: (state, props) => makeSelectLiteTradeMarketDataBySymbol(props.symbol)(state, props),
});

export default connect(mapStateToProps)(withDebounced({
    propNames: ['marketDataSymbol'],
    debounce: 1000
})(memo(LiteTradePortfolioPositionRow)));
